import * as XLSX from 'xlsx';
import imputableService, { tipoCuentaLabel } from '../services/imputableService';
import noImputableService, { formatNoImputableLabel } from '../services/noImputableService';

function visibleEnReporte(v: string | null | undefined): string {
  const s = v != null ? String(v).trim() : '';
  if (!s) return 'Ninguno';
  if (/^ambos$/i.test(s)) return 'Ambos';
  if (/^ninguno$/i.test(s)) return 'Ninguno';
  if (s === 'IVarios' || /^ivarios$/i.test(s)) return 'IVarios';
  if (s === 'EVarios' || /^evarios$/i.test(s)) return 'EVarios';
  return s;
}

/** Exporta plan de cuentas unificado (no imputables + imputables) a PlanCuentas.xlsx. */
export async function exportPlanCuentasExcel(searchTerm: string = ''): Promise<void> {
  const [rowsNoImp, rowsImp] = await Promise.all([
    noImputableService.getAllNoImputablesPlanCuentas(),
    imputableService.getAllImputablesPlanCuentas(searchTerm),
  ]);

  const rubroLookup = new Map(rowsNoImp.map((r) => [r.nroRubro, r]));

  const dataNoImp = [...rowsNoImp]
    .sort((a, b) => a.nroRubro - b.nroRubro)
    .map((item) => ({
      Código: item.nroRubro,
      Nombre: (item.nombreCuenta || item.descripcioncta || '').trim(),
      'Nro. rubro': '',
      'No imputable': '',
      Imputable: 'No',
      'Tipo de cuenta': '',
      'Visible en': '',
      Nivel: item.segmento ?? 0,
      'Totaliza en': item.totalizaEn ?? '',
    }));

  const dataImp = rowsImp.map((item) => {
    const ni = item.nroRubro != null ? rubroLookup.get(item.nroRubro) : undefined;
    return {
      Código: item.codImputable,
      Nombre: item.nombre,
      'Nro. rubro': item.nroRubro ?? '',
      'No imputable':
        item.nroRubro == null || item.nroRubro === 0
          ? '—'
          : ni
            ? formatNoImputableLabel(ni)
            : String(item.nroRubro),
      Imputable: 'Sí',
      'Tipo de cuenta': tipoCuentaLabel(item.tipo),
      'Visible en': visibleEnReporte(item.visibleEn),
      Nivel: '',
      'Totaliza en': '',
    };
  });

  const ws = XLSX.utils.json_to_sheet([...dataNoImp, ...dataImp]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'PlanCuentas');
  XLSX.writeFile(wb, 'PlanCuentas.xlsx');
}
